import { render, staticRenderFns } from "./TailRelationMenuFragment.vue?vue&type=template&id=e270a14c&scoped=true&"
import script from "./TailRelationMenuFragment.vue?vue&type=script&lang=js&"
export * from "./TailRelationMenuFragment.vue?vue&type=script&lang=js&"
import style0 from "./TailRelationMenuFragment.vue?vue&type=style&index=0&id=e270a14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e270a14c",
  null
  
)

export default component.exports